/* This class represents a lead of type Tour Lead for a community. */
export default class CommunityTourLead {
    constructor(formData) {
      this.communityId = formData.id;
      this.mailAddress = formData.email;
      this.name = formData.name;
      this.type = 'postCommunityBrochure';
      this.userPhoneNumber = formData.phone;
      this.leadAction = formData.leadAction;
      this.fromPage = formData.fromPage;
      this.preferredContactMethod = formData.preferredContactMethod;
      this.realtorQuestionAnswerId = formData.realtorQuestion;
      this.date = formData.date;
      this.excludeRecommendations = formData.excludeRecommendations;
      this.guid = formData.guid;
  
      if (formData.postalCode) {
        this.userPostalCode = formData.postalCode;
      } else {
        this.livesOutside = true;
      }
    }
    
    setHousingInformation(properties) {
      this.marketId = properties.marketId;
      this.marketName = properties.marketName;
      this.builderName = properties.brandName;
      this.communityName = properties.communityName;
    }
  }
  